import { render } from "./ProjectReview.vue?vue&type=template&id=513bcc37&scoped=true"
import script from "./ProjectReview.vue?vue&type=script&lang=js"
export * from "./ProjectReview.vue?vue&type=script&lang=js"

import "./ProjectReview.vue?vue&type=style&index=0&id=513bcc37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513bcc37"]])

export default __exports__